export default __webpack_public_path__ + "static/media/logo-lg-1024w.6cf702c4.png";